if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',
    class ShopTheLook extends HTMLElement {
      activeName = 'shop-the-look-point-active';
      constructor() {
        super();
        this.points = this.querySelectorAll('.shop-the-look-container .shop-the-look-point');
        this.container = this.querySelector('.shop-the-look-container');
        this.shopTheCards = this.querySelectorAll('.shop-the-look-card');

        this.points.forEach((point) => {
          point.addEventListener('mouseenter', this.onEnterPoint.bind(this));
          point.addEventListener('mouseleave', this.onLeavePoint.bind(this));
        });
      }

      connectedCallback() {
        this.container.addEventListener('click', this.onClickShopTheLookContainer.bind(this));
        this.shopTheCards.forEach((item) => {
          item.addEventListener('mouseenter', this.onContainerEnter.bind(this));
          item.addEventListener('mouseleave', this.onContainerLeave.bind(this));
        });
      }

      disconnectCallback() {
        this.container.removeEventListener('click', this.onClickShopTheLookContainer.bind(this));

        this.shopTheCards.forEach((item) => {
          item.removeEventListener('mouseenter', this.onContainerEnter.bind(this));
          item.removeEventListener('mouseleave', this.onContainerLeave.bind(this));
        });
      }

      onContainerEnter(event) {
        const points = event.target.querySelectorAll('.shop-the-look-point');
        points.forEach((point) => {
          point.style.display = 'block';
        });
      }

      onContainerLeave(event) {
        const points = event.target.querySelectorAll('.shop-the-look-point');
        points.forEach((point) => {
          point.style.display = 'none';
        });
      }

      openShopTheLookProductList(targetId) {
        const target = this.querySelector('#' + targetId);
        target.style.display = 'block';
      }

      initSlide(target) {
        const swiper = new Swiper(target, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }

      closeShopTheLookProductList(id) {
        const target = this.querySelector('#' + id);
        target.style.display = 'none';
      }

      onClickShopTheLookContainer(event) {
        const button = event.target.closest('.shop-the-look-button');
        if (button) {
          const id = button.dataset.id;
          if (id) {
            this.openShopTheLookProductList(id);
            this.initSlide(this.querySelector(`#${id} .shop-product-list-wrapper`));
          }
          return;
        }
        const clickClose = event.target.closest('.shop-the-look-product-list-heading-close');
        if (clickClose) {
          this.closeShopTheLookProductList(clickClose.dataset.id);
        }
      }

      clearActive() {
        const elements = this.querySelectorAll('.shop-the-look-point');

        elements.forEach((element) => {
          element.classList.remove(this.activeName);
        });
      }

      onEnterPoint(event) {
        const point = event.target.closest('.shop-the-look-point');
        if (point && !point.classList.contains(this.activeName)) {
          this.clearActive();
          point.classList.add(this.activeName);
        }
      }

      onLeavePoint(event) {
        const point = event.target.closest('.shop-the-look-point');
        if (point) {
          point.classList.remove(this.activeName);
        }
      }
    }
  );
}
